import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-button',
  styleUrl: 'button.css',
  shadow: true,
})
export class Button {
  @Prop() href: string = "#";
  @Prop() type: string = "primary";
  @Prop() size: string = "normal";
  @Prop() width: string = ""

  render() {
    return (
      <a href={this.href} class={`btn ${this.type} ${this.size} ${this.width}`}>
        <slot />
      </a>
    );
  }
}
